export default __webpack_public_path__ + "static/media/arrow-white.22af8fc2.svg";